<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <!-- 상세 영역 -->
      <event-list-comp @returnResultCnt="onClickEventListCnt" @returnResultTitle="onClickEventListTitle" @returnQueryResult="callbackQuery" @returnPagingResult="callbackPaging" ref="eventListSearch">
        <div slot="bottomRightArea">
          <md-card-actions md-alignment="space-between">
            <div>
<!--	            <md-button class="md-success md-sm" @click="downloadExcel" v-exel-btn="[5,3]" :disabled="this.pagination.total === 0">
	              <md-icon>get_app</md-icon>Excel 다운로드
	            </md-button>-->
              <md-button class="md-info md-sm" @click="clearEventInfoQueryData(); onClickEventListTitle();">
                <md-icon>event_available</md-icon>신규 행사
              </md-button>
            </div>
          </md-card-actions>
        </div>
      </event-list-comp>
      <!-- 행사 기본 정보 -->
      <md-card v-if="this.isShowBasicInfo">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>
            <span v-show="eventInfoQueryData.eventTitle && eventInfoQueryData.eventTitle != ''">{{ eventInfoQueryData.eventTitle }} - </span>행사 기본 정보
          </h4>
        </md-card-header>
        <md-card-content>
          <h4>행사 기본 정보</h4>
          <table class="flex-table">
            <tr>
              <th>행사명</th>
              <td><input type="text" v-model="eventInfoQueryData.eventTitle"></td>
              <th>참석 대상</th>
              <td><input type="text" v-model="eventInfoQueryData.eventTarget"></td>
              <th>참가비</th>
              <td>
                <div class="inline-flex">
                  <label><input type="radio" value="false" v-model="isEditEventAmt">없음</label>
                  <label><input type="radio" value="true" v-model="isEditEventAmt">있음</label>
                  <input type="text" v-model="eventInfoQueryData.eventAmt" :disabled="isEditEventAmt == 'false'">
                  <span>원</span>
                </div>
              </td>
              <th>행사 시작일</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="eventBegin" v-mask="'####-##-##'">
                </div>
              </td>
              <th>행사 종료일</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="eventEnd" v-mask="'####-##-##'">
                </div>
              </td>
            </tr>
            <tr>
              <th>행사 소개</th>
              <td colspan="9">
                <textarea v-model="eventInfoQueryData.eventDesc"></textarea>
              </td>
            </tr>
            <tr>
              <th>담당부서</th>
              <td><input type="text" v-model="eventInfoQueryData.eventPart"></td>
              <th>담당자</th>
              <td><input type="text" v-model="eventInfoQueryData.eventManager"></td>
              <th>연락처</th>
              <td><input type="text" v-model="eventInfoQueryData.eventTel"></td>
              <td colspan="4"></td>
            </tr>
          </table>

          <h4>행사 결과 정보</h4>
          <table class="flex-table">
            <tr>
              <th>참석인원</th>
              <td colspan="9">
                <span>{{eventInfoQueryData.joinerCnt}}</span>
                <span>명</span>
              </td>
            </tr>
            <tr>
              <th>행사 총평</th>
              <td colspan="9">
                <textarea v-model="eventInfoQueryData.eventReview"></textarea>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="saveEvent()">
            <md-icon>check</md-icon>저 장
          </md-button>
          <md-button class="md-default md-sm" @click="toggleBasicInfo(false)">
            <md-icon>clear</md-icon>취소
          </md-button>
        </md-card-actions>
      </md-card>


      <!-- 행사 참여자 관리 (상세 정보) -->
      <div class="md-layout" v-show="this.isShowDetailInfo">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>search</md-icon>
              {{ eventInfoQueryData.eventTitle }} - 참가자 등록
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table">
              <tr>
                <th>담당부서</th>
                <td>{{eventInfoQueryData.eventPart}}</td>
                <th>담당자</th>
                <td>{{eventInfoQueryData.eventManager}}</td>
                <th>참석대상</th>
                <td>{{eventInfoQueryData.eventTarget}}</td>
                <th>참가비</th>
                <td>{{formatter.getCurrency(eventInfoQueryData.eventAmt)}}</td>
                <th></th>
                <td></td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions md-alignment="right">
            <md-button class="md-info md-sm" @click="setDetailMode(ADD_MEMBER_MODE)">
              <md-icon>person</md-icon>교우 등록
            </md-button>
            <md-button class="md-info md-sm" @click="setDetailMode(ADD_VISITOR_MODE)">
              <md-icon>person</md-icon>외부인 등록
            </md-button>
          </md-card-actions>
        </md-card>

        <!--1. 교우 등록-->
        <div class="md-layout" v-show="this.currentDetailMode === this.ADD_MEMBER_MODE">
          <div class="md-layout-item md-size-20 no-padding">
            <md-card>
              <md-card-header md-alignment="space-between">
                <h4 class="title">
                  <md-icon>search</md-icon>
                  행사 정보
                </h4>
              </md-card-header>
              <md-card-content>
                <div class="flex-div mb10">
                  <h5 class="title">교우 검색 후 추가</h5>

                  <md-button class="md-success md-sm full-size-button" @click="() => {this.isShowUserModal = true}">
                    <md-icon>open_in_new</md-icon>검색 팝업
                  </md-button>
                </div>
                <table class="flex-table mb10">
                  <tr>
                    <th>교우번호</th>
                    <td>{{selectedMember.memberNo}}</td>
                  </tr>
                  <tr>
                    <th>교우명</th>
                    <td>{{selectedMember.memberHnm}}</td>
                  </tr>
                  <tr>
                    <th>교우직위</th>
                    <td>{{selectedMember.memberorgGbNm}}</td>
                  </tr>
                  <tr>
                    <th>대학</th>
                    <td>{{selectedMember.collegeCdNm}}</td>
                  </tr>
                  <tr>
                    <th>학과</th>
                    <td>{{selectedMember.classCdNm}}</td>
                  </tr>
                  <tr>
                    <th>학번</th>
                    <td>{{selectedMember.hakbun}}</td>
                  </tr>
                  <tr>
                    <th>졸업회수</th>
                    <td>{{selectedMember.graduationNo}}</td>
                  </tr>
                  <tr>
                    <th>메모</th>
                    <td><input type="text" v-model="selectedMemberQueryInfo.memo"></td>
                  </tr>
                  <tr>
                    <th>테이블 번호</th>
                    <td><input type="text" v-model="selectedMemberQueryInfo.tableNo"></td>
                  </tr>
                </table>

                <div class="flex-div">
                  <md-button class="md-success md-sm full-size-button" @click="addEventMember" :disabled="!selectedMember.memberNo || selectedMember.memberNo==''">
                    <md-icon>person_add</md-icon>
                    참여자로 추가
                  </md-button>
                </div>
                <hr>
                <div class="flex-div">
                  <h5 class="title">엑셀 업로드</h5>
                  <div class="inline-flex mb10">
                    <input type="file" class="hidden-input-file" id="memberExcelFileInput" accept=".xlsx">
                    <input type="text" v-model="memberExcelFileName" disabled>
                    <button @click="onClickSearchExcel(1)">
                      <md-icon>search</md-icon>엑셀 파일 찾기
                    </button>
                  </div>
                  <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile(1)" :disabled="!memberExcelFile">
                    <md-icon>publish</md-icon>
                    참여자 엑셀 업로드
                  </md-button>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-size-80 no-padding">
            <event-member-joiner-list-comp ref="eventMemberJoinerList" :current-detail-mode.sync="currentDetailMode" :mode-name.sync="ADD_MEMBER_MODE" @refreshEventList="getEventList"></event-member-joiner-list-comp>
          </div>
        </div>


        <!--2. 외부인 등록-->
        <div class="md-layout" v-show="this.currentDetailMode === this.ADD_VISITOR_MODE">
          <div class="md-layout-item md-size-20 no-padding">
            <md-card>
              <md-card-header md-alignment="space-between">
                <h4 class="title">
                  <md-icon>search</md-icon>
                  행사 정보
                </h4>
              </md-card-header>
              <md-card-content>
                <h5 class="title">참여자 입력 정보</h5>
                <table class="flex-table mb10">
                  <tr>
                    <th>성명</th>
                    <td><input type="text" v-model="outjoinerQueryInfo.outjoinerNm"></td>
                  </tr>
                  <tr>
                    <th>비고 1</th>
                    <td><input type="text" v-model="outjoinerQueryInfo.remark1"></td>
                  </tr>
                  <tr>
                    <th>비고 2</th>
                    <td><input type="text" v-model="outjoinerQueryInfo.remark2"></td>
                  </tr>
                  <tr>
                    <th>비고 3</th>
                    <td><input type="text" v-model="outjoinerQueryInfo.remark3"></td>
                  </tr>
                  <tr>
                    <th>메모</th>
                    <td><input type="text" v-model="outjoinerQueryInfo.memo"></td>
                  </tr>
                </table>

                <div class="flex-div">
                  <md-button class="md-success md-sm full-size-button" @click="addEventOutJoiner" :disabled="!outjoinerQueryInfo.outjoinerNm || outjoinerQueryInfo.outjoinerNm == ''">
                    <md-icon>person_add</md-icon>
                    외부인 참여자로 추가
                  </md-button>
                </div>
                <hr>
                <div class="flex-div">
                  <h5 class="title">엑셀 업로드</h5>
                  <div class="inline-flex mb10">
                    <input type="file" class="hidden-input-file" id="outerExcelFileInput" accept=".xlsx">
                    <input type="text" v-model="outerExcelFileName" disabled>
                    <button @click="onClickSearchExcel(2)">
                      <md-icon>search</md-icon>엑셀 파일 찾기
                    </button>
                  </div>
                  <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile(2)" :disabled="!outerExcelFile">
                    <md-icon>publish</md-icon>외부인참여자 엑셀 업로드
                  </md-button>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-size-80 no-padding">
            <event-outer-joiner-list-comp ref="eventOuterJoinerList" :current-detail-mode.sync="currentDetailMode" :mode-name.sync="ADD_VISITOR_MODE" @refreshEventList="getEventList"></event-outer-joiner-list-comp>
          </div>
        </div>
      </div>
      <!-- 행사 참여자 관리 (상세 정보) 끝 -->

      <div id="scrollTargetBox"></div>
    </div>

    <!--교우검색 팝업 -->
    <member-search-pop-comp :is-show.sync="isShowUserModal" @returnResult="onClickModalMember"></member-search-pop-comp>

  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import parser from "@/kuaa/kuaa-parser";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import Swal from "sweetalert2";
import moment from "moment";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import { MemberSearchPopComp } from "@/pages"

import eventListComp from "@/pages/KuaaEvent/Components/eventListComp"
import eventMemberJoinerListComp from "@/pages/KuaaEvent/Components/eventMemberJoinerListComp"
import eventOuterJoinerListComp from "@/pages/KuaaEvent/Components/eventOuterJoinerListComp"

  export default {
    components: {
      eventListComp,
      MemberSearchPopComp,
      eventMemberJoinerListComp,
      eventOuterJoinerListComp
    },
    created() {
    },
    computed: {
    },

    data(){
      return {
        formatter,
        ADD_MEMBER_MODE: "addMemberMode",
        ADD_VISITOR_MODE: "addVisitorMode",

        isShowBasicInfo: false,
        isShowDetailInfo: false,
        currentDetailMode: "addMemberMode",

        isShowUserModal: false,

        isEditEventAmt : 'false', // 행사기본정보 > 참가비

        eventBegin : null, //행사 시작일
        eventEnd : null, //행사종료일

        memberExcelFile: null,
        memberExcelFileName: null,

        outerExcelFile: null,
        outerExcelFileName: null,

        eventListQuery : {
          startDate : null,
          endDate : null,
          eventTitle : ''
        },
        pagination: {},
        selectedMember : {}, // 교우검색에서 선택 한 교우
        selectedMemberQueryInfo : { // 선택한 교우 정보 입력
          memo : '',
          tableNo : ''
        },
        outjoinerQueryInfo : {
          outjoinerNm : '',
          outLevelNm : '',
          outClassNm : '',
          outHakbun : '',
          remark1 : '',
          remark2 : '',
          remark3 : '',
          memo : ''
        },

        eventInfoQueryData : {
          eventTitle : '', //행사명
          eventTarget : '', //참석대상
          eventAmt : 0, //참가비
          eventBegin : null, // 행사시작일
          eventEnd : null, // 행사종료일
          eventDesc : '', // 행사소개
          eventPart : '', // 담당부서
          eventManager : '', // 담당자
          eventTel : '', // 연락처
          joinerCnt : 0, // 참가자 수
          eventReview : '' //총평
        }
      };
    },

    watch : {
      'eventInfoQueryData.eventAmt' : function (n,o) {
        this.isEditEventAmt = ''+n > 0;
      }
    },

    methods: {
      clearEventInfoQueryData () {
        this.eventInfoQueryData = {
          eventTitle : '', //행사명
          eventTarget : '', //참석대상
          eventAmt : 0, //참가비
          eventBegin : null, // 행사시작일
          eventEnd : null, // 행사종료일
          eventDesc : '', // 행사소개
          eventPart : '', // 담당부서
          eventManager : '', // 담당자
          eventTel : '', // 연락처
          joinerCnt : 0, // 참가자 수
          eventReview : '' //총평
        }
        this.eventBegin = null;
        this.eventEnd = null;
      },
      clearMemberInfo(){
        this.selectedMember = {}; // 교우검색에서 선택 한 교우
        this.selectedMemberQueryInfo = { // 선택한 교우 정보 입력
          memo : '',
          tableNo : ''
        };
        this.outjoinerQueryInfo = {
          outjoinerNm : '',
          outLevelNm : '',
          outClassNm : '',
          outHakbun : '',
          remark1 : '',
          remark2 : '',
          remark3 : '',
          memo : ''
        }
      },
      refreshJoinerGrid(item){
        let eventId = item ? item.eventId : null;
        this.clearMemberInfo();
        this.$refs.eventMemberJoinerList.sendQuery(eventId, true);
        this.$refs.eventOuterJoinerList.sendQuery(eventId, true);
      },
      onClickEventListCnt (item){
        console.log('main')
        this.toggleDetailInfo(true,item);
        this.refreshJoinerGrid(item);
      },
      onClickEventListTitle (item){
        this.toggleBasicInfo(true,item);
      },
      toggleBasicInfo(bool,item){
        if (bool){
          this.isShowDetailInfo = false;
          if(item){
            
            this.eventBegin = this.parseDateFormatter(item.eventBegin);
            this.eventEnd = this.parseDateFormatter(item.eventEnd);
            this.eventInfoQueryData = item;
          }else{
            this.clearEventInfoQueryData();
          }
        }
        this.isShowBasicInfo = bool;
      },
      toggleDetailInfo(bool,item){
        this.isShowDetailInfo = bool;
        if (bool){
          this.isShowBasicInfo = false;
          this.eventInfoQueryData = item;
        }
      },
      setDetailMode(modeName){
        this.currentDetailMode = modeName;
      },
      callbackQuery(result){
	    this.eventInfoQueryData = result;
	  },
	  callbackPaging(result){
	    this.pagination = result;
	  },

      saveEvent (){
        // 날짜 포멧
        this.eventInfoQueryData['eventBegin'] = this.customFormatter(this.eventBegin);
        this.eventInfoQueryData['eventEnd'] = this.customFormatter(this.eventEnd);
		
        // 참가비
        this.eventInfoQueryData['eventAmt'] = this.isEditEventAmt = 'true' ? parseInt(this.eventInfoQueryData.eventAmt) : 0;

        kuaaApi.sendServer(
          URL_CONST.SAVE_EVENT_INFO,
          this.eventInfoQueryData,
          "post",
          response => {
            console.log("<<<", response);
            Swal.fire({
              type: "warning",
              showCancelButton: false,
              confirmButtonClass: "md-button md-info",
              cancelButtonClass: "md-button md-default",
              confirmButtonText: "확인",
              buttonsStyling: false,
              html : '저장 되었습니다.'
            });
            this.getEventList();
            this.toggleBasicInfo(false);
          }
        );
      },
      getEventList () {
        this.$refs.eventListSearch.sendQuery();
      },
      onClickModalMember (item){
        this.selectedMemberQueryInfo = {
          memo : '',
          tableNo : ''
        };
        this.selectedMember = item;
        this.isShowUserModal = false;
      },
      addEventMember (){
        let option = {
          eventId : this.eventInfoQueryData.eventId,
          memberNo : this.selectedMember.memberNo,
          memberorgGb : this.selectedMember.memberorgGb,
          outjoinerGb : 'N',
          memo : this.selectedMemberQueryInfo.memo,
          tableNo : this.selectedMemberQueryInfo.tableNo
        }
        this.saveEventJoiner([option]);
      },
      addEventOutJoiner () {
        let option = JSON.parse(JSON.stringify(this.outjoinerQueryInfo));
        option['eventId'] = this.eventInfoQueryData.eventId;
        option['outjoinerGb'] = 'Y';
        this.saveEventJoiner2([option]);
      },
      saveEventJoiner (option) {
        let _this = this;
        kuaaApi.sendServer(
            URL_CONST.GET_EVENT_JOINER_LIST2,
            option[0],
            "post",
            response => {
              if(response.data.data.contents.length > 0){
                let modalOptions = kuaaFnc.getSwalModaloptions({
                  html: "기 등록된 사용자 입니다."
                });
                Swal.fire(modalOptions);
              }else{
                this.saveEventJoiner2(option);
              }
            }
        );
      },
      saveEventJoiner2 (option) {
        kuaaApi.sendServer(
            URL_CONST.SAVE_EVENT_JOINER_LIST,
            option,
            "post",
            response => {
              let modalOptions = kuaaFnc.getSwalModaloptions({
                html: "저장 되었습니다."
              });
              Swal.fire(modalOptions);
              this.refreshJoinerGrid();
            }
        );
      },

      parseDateFormatter (date){
        if(date && date != ''){
          return date.length > 8 ? moment(date,'YYYYMMDDHHmm').format("YYYY-MM-DD") : moment(date).format("YYYY-MM-DD");
        }else{
          return null;
        }
      },
      customFormatter(date) {
        let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
        return res;
      },

      onClickSearchExcel(mode) {
        let input = mode == 1 ? document.getElementById("memberExcelFileInput") : document.getElementById("outerExcelFileInput");
        input.onchange = e => {
          let file = e.target.files[0];
          if(mode == 1){
            this.memberExcelFileName = file.name;
            this.memberExcelFile = file;
          }else{
            this.outerExcelFileName = file.name;
            this.outerExcelFile = file;
          }
        };
        input.click();
      },

      uploadExcelFile(mode) {
        let xls = mode == 1 ? this.memberExcelFile : this.outerExcelFile;
        parser.parseXlsEventMemberData(xls, (res)=>{
          if(mode == 1){
            this.parseMemberXls(res)
          }else{
            this.parseOuterXls(res)
          }
        });
      },

      parseMemberXls(xlsData){
        let req = [];
        xlsData.forEach((item)=>{
          req.push({
            eventId : this.eventInfoQueryData.eventId,
            memberNo : item['MEMBER_NO'] ? item['MEMBER_NO'] : '',
            outjoinerGb : 'N',
            memo :  item['MEMO'] ? item['MEMO'] : '',
            tableNo : item['TABLE_NO'] ? item['TABLE_NO'] : ''
          })
        });
        this.saveEventJoiner2(req);
      },

      parseOuterXls(xlsData){
        let req = [];
        xlsData.forEach((item)=>{
          req.push({
            eventId : this.eventInfoQueryData.eventId,
            outjoinerNm : item['OUTJOINER_NM'] ? item['OUTJOINER_NM'] : '',
            outjoinerGb : 'Y',
            remark1 : item['REMARK_1'] ? item['REMARK_1'] : '',
            remark2 : item['REMARK_2'] ? item['REMARK_2'] : '',
            remark3 : item['REMARK_3'] ? item['REMARK_3'] : '',
            memo : item['MEMO'] ? item['MEMO'] : '',
          })
        });
        this.saveEventJoiner2(req);
      }
    }
  };
</script>

<style>

</style>